import { render, staticRenderFns } from "./PublishedReleased.vue?vue&type=template&id=1920bcba&scoped=true&"
var script = {}
import style0 from "./PublishedReleased.vue?vue&type=style&index=0&id=1920bcba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1920bcba",
  null
  
)

export default component.exports